// Сервис который необходим всем репозиториям
import { ApiService } from '../service/api/ApiService'
// Регистрация Репозиториев
import { InviteRepository } from '../repository/invite/InviteRepository'
// import { PermissionsRepository } from '../repository/permissions/PermissionsRepository'
// Регистрация сервисов
import { EventBus } from '../event-bus/event-bus'
import { InviteStatusesService } from '../service/invite/InviteStatusesService'
import { ApiErrorTransformer } from '../service/api/ApiErrorTransformer'
// import { PersonalCabinetRepository } from '../repository/company/PersonalCabinetRepository'
// import { ProfileRepository } from '../repository/profile/ProfileRepository'
// import { EmployeeRepository } from '../repository/employee/EmployeeRepository'
// import { BankRepository } from '../repository/banks/BankRepository'
// import { BankAccountRepository } from '../repository/banks/BankAccountRepository'
// import { BankDetailsRepository } from '../repository/bank-details/BankDetailsRepository'
// import { BankAccountStatementRepository } from '../repository/banks/BankAccountStatementRepository'
// import { RoleRepository } from '../repository/role/RoleRepository'
// import { CounterpartiesRepository } from '../repository/counterparties/CounterpartiesRepository'

export default {
    inviteRepository: new InviteRepository(ApiService),
    // personalCabinetRepository: new PersonalCabinetRepository(ApiService),
    // bankAccountRepository: new BankAccountRepository(ApiService),
    // profileRepository: new ProfileRepository(ApiService),
    // bankRepository: new BankRepository(ApiService),
    // bankDetailsRepository: new BankDetailsRepository(ApiService),
    inviteStatusService: new InviteStatusesService(),
    // employeeRepository: new EmployeeRepository(ApiService),
    // bankAccountStatementRepository: new BankAccountStatementRepository(ApiService),
    eventBus: EventBus,
    apiErrorTransformer: new ApiErrorTransformer(),
    // permissionsRepository: new PermissionsRepository(ApiService),
    // counterpartiesRepository: new CounterpartiesRepository(ApiService),
    // roleRepository: new RoleRepository(ApiService),
}
